module.exports = "/fonts/fa-brands-400.eot?03783c5172ee1ad128c576bf88fac168";